import React from "react";
import { Helmet } from "react-helmet-async";
import { publicSiteUrl } from "@/lib/share";

// Reusable per-page SEO controls (Googlebot renders JS and reads these).
// Purely additive: pages that already inject OG/canonical/title imperatively can pass
// only `robots` and/or `jsonLd` here without conflicting. `canonical` accepts a path
// (turned into an absolute production URL) or an absolute URL.
export function Seo({ title, description, canonical, robots = "index,follow", jsonLd }) {
  let canonHref = canonical;
  if (canonical && canonical.startsWith("/")) canonHref = `${publicSiteUrl()}${canonical}`;
  const blocks = Array.isArray(jsonLd) ? jsonLd.filter(Boolean) : jsonLd ? [jsonLd] : [];
  return (
    <Helmet>
      {title ? <title>{title}</title> : null}
      {description ? <meta name="description" content={description} /> : null}
      <meta name="robots" content={robots} />
      <meta name="googlebot" content={robots} />
      {canonHref ? <link rel="canonical" href={canonHref} /> : null}
      {blocks.map((obj, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(obj)}</script>
      ))}
    </Helmet>
  );
}

// PropertyConnect Organization — conservative, used on primary public pages.
export const organizationJsonLd = () => ({
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "PropertyConnect",
  alternateName: "PropConnect AI",
  url: publicSiteUrl(),
  logo: `${publicSiteUrl()}/brand/pc-appicon-512.png`,
  description:
    "PropertyConnect connects real estate professionals, properties and active buyer demand through intelligent matching and collaboration.",
});

// PropertyConnect WebSite — homepage identity (P1.2). No SearchAction in P1.2.
export const websiteJsonLd = () => ({
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "PropertyConnect",
  alternateName: "PropConnect AI",
  url: publicSiteUrl(),
  description:
    "Discover properties, connect with real estate professionals, and explore opportunities across the Philippines with PropertyConnect.",
});

export default Seo;
